<ctx-chemical-thumbnail [size]="'l'" [chemical]="chemical()" />

<div class="chemical-revision-row__information">
	<div class="chemical-revision-row__information-header">
		<p class="m-0">
			{{ revision().regulationNumber }}
		</p>
	</div>

	<small class="m-0">
		@if (revision().expiresAt.toDate(); as expiresAt) {
			@if (expiresAt | isExpired) {
				<span class="text-red-500">
					{{
						'data.expired-on'
							| transloco: { date: expiresAt | date: 'longDate' }
					}}
				</span>
			} @else {
				{{
					'data.expires-on'
						| transloco: { date: expiresAt | date: 'longDate' }
				}}
			}
		}
	</small>
</div>

<div class="chemical-revision-row__actions">
	@if (isLatestRevision()) {
		<span tuiBadge appearance="positive">
			<tui-icon icon="@tui.check-circle" />
			{{ 'chemical.latest-revision' | transloco }}
		</span>
	}

	@if (menuItems().length) {
		@if ('mobile' | isDevice) {
			<button
				size="m"
				tuiIconButton
				appearance="ghost"
				(click)="onMenuOpen()"
			>
				<tui-icon icon="@tui.ellipsis" />
			</button>
		} @else {
			<button
				size="m"
				tuiIconButton
				appearance="ghost"
				[tuiDropdown]="revisionDropdown"
				[(tuiDropdownOpen)]="menuOpen"
			>
				<tui-icon icon="@tui.ellipsis" />
			</button>
		}
	}
</div>

<ng-template #revisionDropdown>
	<ctx-detail-menu-dropdown [menuItems]="menuItems()" />
</ng-template>
